import * as React from "react";
import styled from "styled-components";
import { CheckBox, CheckBoxProps } from "grommet";

interface Props extends CheckBoxProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const CheckBoxInput = styled(CheckBox)``;
